module.exports = __webpack_public_path__ + "img/tick.d5cd4838.svg";